export const isDomainCustom = (domain: string) => domain !== process.env.NEXT_PUBLIC_SIO_HOSTNAME

export const isCustomDomain = () =>
  (typeof window !== 'undefined' && isDomainCustom(window.location.hostname)) || false
